import CoolCardItem from './CardItem/CoolCardItem'
import CarouselHeader from './CarouselHeader/CarouselHeader'
import { CoolMultiCardCarouselContainer, CoolMultiCardsContainer } from './styledComponents'

export default function CoolMultiCardCarousel({
  carouselHeading,
  carouselSubHeading,
  cards = [],
  mainContainerStyles = {},
  cardsContainerStyles = {},
  MainContainerStyledComponent = CoolMultiCardCarouselContainer,
}) {
  const cardsToConsider = cards.slice(0, 4)

  return (
    <MainContainerStyledComponent style={mainContainerStyles}>
      <CarouselHeader heading={carouselHeading} subHeading={carouselSubHeading} />
      <CoolMultiCardsContainer style={cardsContainerStyles}>
        {cardsToConsider?.map((card, idx) => {
          return (
            <CoolCardItem
              key={idx}
              headingIconComponent={card?.headingIcon}
              heading={card?.heading}
              description={card?.description}
              subHeading={card?.subHeading}
              extraStyles={card?.styles}
            />
          )
        })}
      </CoolMultiCardsContainer>
    </MainContainerStyledComponent>
  )
}
